// Basic imports
import { createApp } from "vue";
import TheApp from "@/App.vue";
import { router } from "@/router";

// Plugins
import "@/plugins/dayjs";

// Tooltips
import FloatingVue from "floating-vue";

import "@/scss/properties.scss";
import "@/scss/general/general.scss";

// Element plus
import { ElLoading } from "element-plus";

// 3rd party logins
import vue3GoogleLogin from "vue3-google-login";

// Translations
import { gettext } from "@/services/translation";

// Toasts
import { toasts } from "@/services/toasts";

// HTML <head> tag
import { createHead } from "@unhead/vue/client";

// Custom directives
import errorShake from "@/directives/errorShake";

// Onload animations (and more)
import { MotionPlugin } from "@vueuse/motion";

window.appVersion = import.meta.env.VITE_APP_VERSION; // Sentry (in GTM) uses this information.

const app = createApp(TheApp);
app.use(gettext);
app.use(createHead());
app.use(vue3GoogleLogin, { clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID });
app.use(router);
app.use(FloatingVue);
app.use(MotionPlugin);
app.use(toasts);

app.directive("loading", ElLoading.directive);
app.directive("error-shake", errorShake);

app.mount("#app");
